<template>
  <el-card>
    <div style="display:flex; justify-content: flex-start;"> 
      <el-image :src ="logo2" style="height: 50px; "  fit="cover"> </el-image>
      <!-- <h1 style="margin: 0 auto; ">{{ theme }}</h1> -->
    </div>
    <el-divider ></el-divider>
    <div style="display: flex; justify-content: space-between;  ">
      <div style="text-align: left">
          <span style="margin-left: 5px; height:16px;width:10px;background:#38e8eb; display: inline-block"> </span>
          <span style="font-size:18px;  font-weight:700">{{ fileType }}</span>
      </div>
      <el-checkbox v-if =  " fileType != '通知公告' &&  fileType != '办事指南' "  v-model="basicState" disabled >实验室准入教程</el-checkbox>
    </div>
    <div class = "w-e-text-container">
      <div data-slate-editor style="overflow:auto !important;  height: calc(100vh - 300px)" v-html="content">
      </div>
    </div>
    <div style=" display:flex; " v-if=" funtFootType==2" >
      <div style="margin-left:100px">
        <el-tag size="medium" type = "primary" >您的签名</el-tag>
      </div>
      <div>
        <el-image :src ="fileUrl" fit ="fit" style= "border: 1px solid black; width:700px;height: 150px;"> 
        </el-image>
      </div>
    </div>
    <div style=" display:flex;margin-top: 10px;"  v-else-if=" funtFootType==1 && fileUrl != null && fileUrl != ''" >
      <div style="margin-left:100px">
        <el-tag size="medium" type = "primary" >附件</el-tag>
      </div>
      <div style="margin-left:10px">
        <el-link type="primary" @click = "attachDownLoad" >{{ fileName }}</el-link>
      </div>
    </div>
  </el-card>
</template>                     
<script>
// 引入组
import '@wangeditor/editor/dist/css/style.css'
import axios from  '@/api/axiosConfig'
import {getToken} from  '@/api/utils'
import {MESSAGE_DURATION,fileType} from  '@/api/constant'
import logo2 from "@/assets/image/logo2.jpg"
export default {
  name : 'pc_ctr_editor_view',
  data() {
    return {
      funtFootType : '',
      logo2,
      id :"",
      basicState : false,
      theme : "",
      content:"",
      fileType : "",
      fileName:'',
      fileUrl :'',
      tokenObj:{
          token :''
      }
    }
  },
  methods : {

    attachDownLoad(){
      let that = this
      let outData = {}  //传参数据
      let url = this.fileUrl; //接口
      let xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = "blob";  // 返回类型blob
      xhr.setRequestHeader("Content-type", "application/json;charset=utf-8");
      xhr.setRequestHeader("token", this.tokenObj.token); //这个看后端接口情况决定要不要写
      // 定义请求完成的处理函数，请求前也可以增加加载框/禁用下载按钮逻辑
      xhr.onload = function () {
          // 请求完成
          if (this.status === 200) {
              // 返回200
              var blob = this.response;
              const a = document.createElement('a');
              const url = window.URL.createObjectURL(blob);
              let reader = new FileReader();
              reader.readAsDataURL(blob);  // 转换为base64，可以直接放入a表情href
              reader.onload = function (e) {
                  // 转换完成，创建一个a标签用于下载
                let a = document.createElement('a');
                a.download = that.fileName;
                a.href = e.target.result;
                document.body.appendChild(a);
                // 修复firefox中无法触发click
                a.click();
                document.body.removeChild(a);
              }
          } else {
            that.$message({
              showClose: true,
              message: "下载失败：" + xhr.statusText,
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
      };
      xhr.onerror = function () {
        that.$message({
          showClose: true,
          message: "下载失败：" + xhr.statusText,
          type: 'info',
          duration: MESSAGE_DURATION
        })
      }
      // 发送ajax请求
      xhr.send(JSON.stringify(outData))
    },
    // 加载一个通知公告
    noticeOneLoad(id){
      let _this = this
      let url = "/bc/exa/notice/getNoticeInfo"
      let dat0 = {
        id: id
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          if(response.data.data != null &&  response.data.data != ''){
            this.content= response.data.data.content 
            this.theme = response.data.data.theme
            let attachFileList = response.data.data.attachFileList
            if(attachFileList != null && attachFileList.length!= 0){
              this.funtFootType = 1
              this.fileName = attachFileList[0].fileName
              this.fileUrl = attachFileList[0].url
            }
          } else {
            _this.$message({
                showClose: true,
                message: '未查询相关信息！',
                type: 'info',
                duration: MESSAGE_DURATION
            })
          }
        }else{
          _this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err)=>{
          _this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      });
    },
    // 加载一个安全知识
    knOneLoad(id){
      let url = "/bc/exa/kn/getKnInfo"
      let dat0 = {
        id: id
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          if(response.data.data != null &&  response.data.data != ''){
            this.content= response.data.data.content 
            this.theme = response.data.data.theme
            this.basicState = response.data.data.basicState == 1
            let attachFileList = response.data.data.attachFileList
            if(attachFileList != null && attachFileList.length!= 0){
              this.funtFootType = 1
              this.fileName = attachFileList[0].fileName
            }
          } else {
            this.$message({
                showClose: true,
                message: '未查询相关信息！',
                type: 'info',
                duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err)=>{
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
        })
      });
    },
    // 加载一个规章制度
    regOneLoad(id){
      let url = "/bc/exa/reg/getRegInfo"
      let dat0 = {
        id: id
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          if(response.data.data != null &&  response.data.data != ''){
            this.content= response.data.data.content 
            this.theme = response.data.data.theme
            this.basicState = response.data.data.basicState == 1
            let attachFileList = response.data.data.attachFileList
            if(attachFileList != null && attachFileList.length!= 0){
              this.funtFootType = 1
              this.fileName = attachFileList[0].fileName
              this.fileUrl = attachFileList[0].url
            }
          } else {
            this.$message({
                showClose: true,
                message: '未查询相关信息！',
                type: 'info',
                duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err)=>{
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
        })
      });
    },
    // 加载一个办事指南
    guidOneLoad(id){
      let url = "/bc/exa/guid/getGuidInfo"
      let dat0 = {
        id: id
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          if(response.data.data != null &&  response.data.data != ''){
            this.content= response.data.data.content 
            this.theme = response.data.data.theme
            let attachFileList = response.data.data.attachFileList
            if(attachFileList != null && attachFileList.length!= 0){
              this.funtFootType = 1
              this.fileName = attachFileList[0].fileName
              this.fileUrl = attachFileList[0].url
            }
          } else {
            this.$message({
                showClose: true,
                message: '未查询相关信息！',
                type: 'info',
                duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err)=>{
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
        })
      });
    },
    safeBookOneLoad(id){
      let arr =   id.split("_")
      let url = "/bc/exa/safeBook/getSafeBookInfo"
      let dat0 = {
        id: arr[0],student:false,userId :arr[1]
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          if(response.data.data != null &&  response.data.data != ''){
            this.content= response.data.data.content 
            this.theme = response.data.data.theme
            this.basicState = response.data.data.basicState == 1
            let fileTreeId = response.data.data.fileTreeId
            if(fileTreeId != null && fileTreeId != '' ){
              this.funtFootType = 2
              this.fileUrl = response.data.data.signImage
            }
          } else {
            this.$message({
                showClose: true,
                message: '未查询相关信息！',
                type: 'info',
                duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err)=>{
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
        })
      });
    }
  },
  created () {
    setTimeout(()=>{getToken(this.tokenObj)},200)
    this.id = this.$route.params.id
    this.fileType =  this.$route.query.fileType
    switch(this.fileType) {
      case fileType.NOTICE_FILE:
          this.noticeOneLoad(this.id)
          break
      case fileType.SAFE_KNOWLEDGE:
          this.knOneLoad(this.id)
          break   
      case fileType.REGULATIONS.NAME:
          this.regOneLoad(this.id)
          break   
      case fileType.WORK_GUID:
        this.guidOneLoad(this.id)
        break   
      case fileType.SAFE_BOOK:

        this.safeBookOneLoad(this.id)
        break  
    }
  }
}
</script>

<style lang="less" scoped>
.el-card {
  height: 99%
}
.text {
  font-size: 14px;
  color: #000;
}

.notice-content-view {
  border: 3px solid #ccc;
  border-radius: 5px;
  padding: 0 10px;
  margin-top: 20px;
  overflow-x: auto;
}

.notice-content-view p,
.notice-content-view li {
  white-space: pre-wrap; /* 保留空格 */
}

.notice-content-view blockquote {
  border-left: 8px solid #d0e5f2;
  padding: 10px 10px;
  margin: 10px 0;
  background-color: #f1f1f1;
}

.notice-content-view code {
  font-family: monospace;
  background-color: #eee;
  padding: 3px;
  border-radius: 3px;
}
.notice-content-view pre>code {
  display: block;
  padding: 10px;
}

.notice-content-view table {
  border-collapse: collapse;
}
.notice-content-view td,
.notice-content-view th {
  border: 1px solid #ccc;
  min-width: 50px;
  height: 20px;
}
.notice-content-view th {
  background-color: #f1f1f1;
}

.notice-content-view ul,
.notice-content-view ol {
  padding-left: 20px;
}

.notice-content-view input[type="checkbox"] {
  margin-right: 5px;
}
.el-divider--horizontal{
  background-color: #3d2e9f;
  height: 2px;
  margin: 1px 0 10px 0;
  width: 100%
}
</style>
    


// WEBPACK FOOTER //
// src/pc_pages/pc_ctr_component/pc_ctr_editor_view.vue